import React from 'react';
import { Link } from 'react-router-dom';
import { typography, spacing, transitions } from '../utils/designTokens';

export default function Breadcrumb({ items }) {
  if (!items || !Array.isArray(items)) throw new Error('Breadcrumb requires items array prop');
  if (items.length === 0) throw new Error('Breadcrumb items array cannot be empty');

  return (
    <div className={`flex items-center ${spacing.gap.sm} ${typography.size.sm}`}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.to ? (
            <Link
              to={item.to}
              className={`text-text-muted hover:text-text-primary ${transitions.colors}`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={`text-text-primary ${typography.weight.medium} truncate`}>
              {item.label}
            </span>
          )}
          {index < items.length - 1 && (
            <span className="text-text-muted">{">"}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
